
module.exports = {
	getPageYOffset() {
		return window.pageYOffset;
	},

	getPageXOffset() {
		return window.pageXOffset;
	},

	getInnerHeight() {
		return window.innerHeight;
	},

	getInnerWidth() {
		return window.innerWidth;
	},
	
	createRadio(uid, doc) {
		var radio = doc.createElement('input');
		radio.type = 'radio';
		radio.name = uid;
		return radio;
	},

	setInputTypeNumber(input) {
		input.type = 'number';
	}
};
